import {
  DELIVERY_ZIP_TYPES,
  STORAGE_IDENTIFIERS,
  TIMESPANS,
  WORKFLOWS,
} from "./common/constants";
import { isAPOFPOZipCode } from "./common/utils";
import HttpError from "./error/HttpError";
import localizationServiceProxy from "./localizationServiceProxy";
import cookie from "./storageManager/methods/cookie";

export const getDeliveryZipCookie = () => {
  return cookie.get(STORAGE_IDENTIFIERS.DELIVERY_ZIP);
};

export const getDeliveryZipTypeCookie = () => {
  return cookie.get(STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE);
};

export const determineZipcodeType = (workflow) => {
  if (workflow === WORKFLOWS.LOCALIZED_BY_ZIPCODE) {
    return DELIVERY_ZIP_TYPES.USER;
  }

  if ([WORKFLOWS.DEFAULT, WORKFLOWS.LOCALIZED_BY_DEFAULT].includes(workflow)) {
    return DELIVERY_ZIP_TYPES.DEFAULT;
  }
  return DELIVERY_ZIP_TYPES.AUTO;
};

const deliveryZipcodeService = {
  getDeliveryZipcodeDetails() {
    const zipcode = getDeliveryZipCookie();
    const { shownDefault, type } = this.getDeliveryZipcodeType() || {};
    if (type) {
      return { shownDefault, type, zipcode };
    }
    return { zipcode };
  },
  getDeliveryZipcodeType() {
    try {
      const type = getDeliveryZipTypeCookie();
      if (type) {
        return {
          shownDefault: type !== DELIVERY_ZIP_TYPES.DEFAULT,
          type,
        };
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeDetails(zipcode, type) {
    try {
      if (zipcode) {
        cookie.put({
          key: STORAGE_IDENTIFIERS.DELIVERY_ZIP,
          value: zipcode.toString().trim(),
          expireTime: TIMESPANS.ONE_YEAR,
        });
      }
      if (type) {
        const typeFromStorage = cookie.get(
          STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE
        );
        if (typeFromStorage !== DELIVERY_ZIP_TYPES.USER) {
          cookie.put({
            key: STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE,
            value: type,
            expireTime: TIMESPANS.ONE_YEAR,
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeFromLocalizerResponse(localizerResponse) {
    try {
      const workflow = localizerResponse?.status?.getWorkflow();
      const type = determineZipcodeType(workflow);
      const deliveryZipCookie = getDeliveryZipCookie();
      const deliveryZipTypeCookie = getDeliveryZipTypeCookie();
      if (!deliveryZipCookie) {
        const localStoreZip = localizerResponse.getLocalizedStore().zipcode;
        if (localStoreZip) {
          this.updateDeliveryZipcodeDetails(localStoreZip, type);
        }
      } else if (!deliveryZipTypeCookie) {
        this.updateDeliveryZipcodeDetails(deliveryZipCookie, type);
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeOnLocalizationWorkflow(localStore, workflow, zipcode) {
    try {
      const type = determineZipcodeType(workflow);
      this.updateDeliveryZipcodeDetails(
        zipcode || localStore?.address?.postalCode,
        type
      );
    } catch (e) {
      console.error(e);
    }
  },
  async validateUSZipcode(
    zipcode,
    successCallback,
    failureCallback,
    errorCallback
  ) {
    try {
      const httpResponse = await localizationServiceProxy.getZipCodeData(
        zipcode
      );
      if (httpResponse?.locations?.length > 0) {
        if (successCallback) {
          successCallback(httpResponse);
        }
      } else {
        if (failureCallback) {
          failureCallback(httpResponse);
        }
      }
    } catch (e) {
      if (failureCallback && e instanceof HttpError) {
        failureCallback(e);
      } else if (errorCallback) {
        errorCallback(e);
      }
    }
  },
  isAPOFPOZipCode() {
    const zipcode = getDeliveryZipCookie();

    return isAPOFPOZipCode(zipcode);
  },
};

export default deliveryZipcodeService;